<mat-card appearance="outlined" class="custom-price-card">
  <ng-container>
    <form>
      <mat-card-header>
        <div
          *ngIf="item.icon"
          mat-card-avatar
          style="background-image: url({{ item.icon }}); background-size: cover; "
        ></div>
        <mat-card-title>Wholesale Cost</mat-card-title>
        <mat-card-subtitle>{{ item.name }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content
        *ngIf="item.appPrices.pricesForContexts['wholesale'] && partnerCurrency$ | async as partnerCurrency"
      >
        <p>Enter the amount you'll spend each billing period.</p>
        <billing-ui-variable-price-input
          (spendAmountChanged)="updateOrderItem($event)"
          [currentSpendAmount]="minValue"
          [appPrice]="item.appPrices.pricesForContexts['wholesale']"
          [currencyCode]="partnerCurrency"
        ></billing-ui-variable-price-input>
      </mat-card-content>
    </form>
  </ng-container>
</mat-card>
